import { useEffect, useRef } from "react";

type Options<T> = {
  sectionId: string | null;
  data: T | undefined;
  previousData: T | undefined;
  loading: boolean;
  enabled: boolean;
};

export default function useSectionScopedQueryData<T>({
  sectionId,
  data,
  previousData,
  loading,
  enabled
}: Options<T>): T | undefined {
  const lastResolvedSectionId = useRef(sectionId);

  useEffect(() => {
    if (enabled && !loading && data !== undefined) {
      lastResolvedSectionId.current = sectionId;
    }
  }, [data, enabled, loading, sectionId]);

  if (!enabled) {
    return undefined;
  }

  if (loading && lastResolvedSectionId.current !== sectionId) {
    return undefined;
  }

  return data ?? (lastResolvedSectionId.current === sectionId ? previousData : undefined);
}
